module.exports = __webpack_public_path__ + "static/gabriel-ribeiro-b4511362ad39358718d5eab4ffb38ad6.png";